$(function() {
    initHeaderDropdowns();
    initAccordions();
  
    if ($(window).innerWidth() <= 568) {
      // turn MagicZoom off for mobile
      MagicZoomPlus.stop();
    }
})

// HEADER DROPDOWNS

function initHeaderDropdowns() {
    $('.mobile-nav > a').click(function(e) {
        e.preventDefault();
        toggleHeaderDropdown($(this).siblings('.nav-container'));
    })
    
    
    dropdownMaxHeight();
    $(window).resize(function() {
    	dropdownMaxHeight();
    });
}

function dropdownMaxHeight() {
  window_height = $(window).innerHeight();
  max_height = window_height - 44;
  $('.nav-container').css('max-height', max_height + 'px');
}

function toggleHeaderDropdown(dropdown) {
    $('.mobile-nav > .nav-container:visible').not(dropdown).slideUp();
    dropdown.slideToggle();
}


// ACCORDIONS
function initAccordions() {
    $('.accordion-title').click(function(e) {
        e.preventDefault();
        toggleAccordion($(this).closest('.accordion'));
    })
}

function toggleAccordion(accordion) {
    accordion.find('.accordion-content').slideToggle();
}